import { render, staticRenderFns } from "./MainConfiguration.vue?vue&type=template&id=09719c70&scoped=true"
import script from "./MainConfiguration.vue?vue&type=script&lang=js"
export * from "./MainConfiguration.vue?vue&type=script&lang=js"
import style0 from "./MainConfiguration.vue?vue&type=style&index=0&id=09719c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09719c70",
  null
  
)

export default component.exports